<template>
  <div>
    <ValidationProvider
      :ref="validationProviderRef"
      :mode="veeValidateInteractionMode"
      :rules="nonConfirmRules"
      :vid="validationProviderRef"
      :debounce="validationDelay"
      :name="label"
    >
      <v-text-field
        :id="validationProviderRef"
        v-model="data"
        slot-scope="{ errors }"
        :data-cy="dataCy"
        :errorMessages="errors"
        :label="displayedLabel(label)"
        :required="isRequired"
        :disabled="disabled"
        :appendIcon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showPassword ? 'text' : 'password'"
        v-bind="$attrs"
        v-on="$listeners"
        @click:append="showPassword = !showPassword"
        @input="$emit('input', data)"
      />
    </ValidationProvider>
    <ValidationProvider
      v-if="passwordConfirm"
      :rules="confirmRules"
      :debounce="validationDelay"
      :name="confirmPasswordLabel"
    >
      <v-text-field
        v-model="confirmData"
        slot-scope="{ errors }"
        :errorMessages="errors"
        :label="displayedLabel(confirmPasswordLabel)"
        :required="isRequired"
        :disabled="disabled"
        :appendIcon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showConfirmPassword ? 'text' : 'password'"
        v-bind="$attrs"
        v-on="$listeners"
        @click:append="showConfirmPassword = !showConfirmPassword"
        @input="$emit('input', data)"
      />
    </ValidationProvider>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import validationProviderHelperMixin from '@/components/shared/widgets/forms/validationHelper/validationProviderHelperMixin';

export default {
    components: {
        ValidationProvider,
    },
    mixins: [
        validationProviderHelperMixin,
    ],
    props: {
        label: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        rules: {
            type: Object,
            default: undefined,
        },
        passwordConfirm: {
            type: Boolean,
            default: false,
        },
        extraClass: {
            type: String,
            default: null,
        },
        dataCy: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            showPassword: false,
            showConfirmPassword: false,
            data: this.value,
            confirmData: '',
            nonConfirmRules: this.rules || { required: true, min: 8, max: 200 },
        };
    },
    computed: {
        confirmRules() {
            return { ...this.nonConfirmRules, confirmed: this.validationProviderRef };
        },
        confirmPasswordLabel() {
            return this.$t('forms.labels.repeatPassword');
        },
        isRequired() {
            return Object.keys(this.nonConfirmRules).some(rule => rule === 'required' && this.nonConfirmRules[rule]);
        },
        displayedLabel() {
            return label => `${label} ${this.isRequired ? '*' : ''}`;
        },
    },
};
</script>
